import { Routes } from '@angular/router';
import { AutorizacaoGuard } from 'src/app/shared/guards/autorizacao.guard';
import { ContainerComponent } from 'src/app/shared/componentes/layout/container/container.component';
import { LoginContainerComponent } from './auth/login-container/login-container.component';
import { naoEncontradoComponent } from './shared/componentes/nao-encontrado/nao-encontrado.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'auth' },
  {
    path: 'sistema',
    data: {
      breadcrumb: null,
    },
    canActivate: [AutorizacaoGuard],
    component: ContainerComponent,
    loadChildren: () => import('./modules/routes'),
  },
  {
    path: 'auth',
    component: LoginContainerComponent,
    loadChildren: () => import('./auth/auth.routes'),
  },
  {
    path: '**',
    component: naoEncontradoComponent,
  },
];
